export default "__VITE_ASSET__3cbf836d__"